<template>
  <el-row>
    <el-col :xs='20' :sm='9' :md='7' :lg='6' :xl='4' :span="4" v-loading="loadingAssignedApplications">
      <applications-lane :assignedApplications="assignedApplications" :assignedApps="assignedApps"></applications-lane>
    </el-col>
        <transition name="el-fade-in-linear">
      <el-col :xs='24' :sm='15' :md='17' :lg='18' :xl='16' v-loading="loadingWorkingApplication">
        <div class="grid-content bg-purple">
          <el-card class="box-card bg-purple" v-if="showWorkingApplication">
            <div slot="header" class="clearfix">
              <UserAppInfo></UserAppInfo>
            </div>
            <div class="text item">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="Προσωπικά Στοιχεία" name="first">
                  <personal-details :personalDetails="workingApplication.personalDetails"></personal-details>
                </el-tab-pane>
                <el-tab-pane v-if="!isReappraisal" label="Τίτλος Σπουδών" name="second">
                  <titles :application="workingApplication"></titles>
                </el-tab-pane>
                 <el-tab-pane label="Συνυποβολή Τίτλου" name="third" v-if='workingApplication.consideration === true'>
                  <title-consideration :application="workingApplication"></title-consideration>
                </el-tab-pane>
                <el-tab-pane label="Επισυναπτόμενα" name="fourth">
                  <attached-documents
                    :attachedDocumentsTable="attachedDocumentsTable"
                    :neededDocuments="workingApplication.neededDocuments"
                    :appId="workingApplication.id"
                    :role="role">
                  </attached-documents>
                </el-tab-pane>
                <el-tab-pane label="Ιστορικό" name="fifth" :lazy=true>
                  <history-line :applicationHistory="history"></history-line>
                </el-tab-pane>
                <el-tab-pane label="Αποτέλεσμα Επεξεργασίας" name="sixth">
                  <vice-president-a-judgment  :application='workingApplication' :isReappraisal="isReappraisal"></vice-president-a-judgment>
                </el-tab-pane>
              <el-tab-pane label="Σχετική αίτηση" name="seventh" v-if="isReappraisal">
                  <relevant-app :relevantApp="workingApplication.relevantApplication"></relevant-app>
              </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
        <application-search v-show="searchVisible"></application-search>
        <search-uni v-show="searchUniVisible"></search-uni>
      </el-col>
    </transition>
  </el-row>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
// import axios from 'axios'
import PersonalDetails from './common/PersonalDetails'
import RelevantApp from './common/RelevantApp'
import Titles from './common/Titles'
import TitleConsideration from './common/TitleConsideration'
import AttachedDocuments from './common/AttachedDocuments'
import HistoryLine from './common/HistoryLine'
import VicePresidentAJudgment from './roleSpecific/VicePresidentAJudgment'
import ApplicationsLane from './common/ApplicationsLane'
import UserAppInfo from './common/UserAppInfo'
import ApplicationSearch from '@/components/common/ApplicationSearch'
import SearchUni from '@/components/common/SearchUni'

export default {
  name: 'VicePresidentA',
  components: {
    PersonalDetails,
    RelevantApp,
    Titles,
    TitleConsideration,
    AttachedDocuments,
    HistoryLine,
    VicePresidentAJudgment,
    ApplicationsLane,
    UserAppInfo,
    ApplicationSearch,
    SearchUni
  },
  mounted: function () {
    this.$store.dispatch('LOAD_INTERNAL_USERS')
  },
  data () {
    return {
      activeName: 'first',
      role: this.activeRole,
      notificationsDialogVisible: false,
      assignedApps: {viceW_President: [{ id: '1', surname: '', createdAt: '', degreeType: '' }],
        viceW_Prechecker: [{ id: '2', surname: '', createdAt: '', degreeType: '' }],
        viceW_Board: [{ id: '3', surname: '', createdAt: '', degreeType: '' }],
        viceW_ReappraisalBoard: [{ id: '4', surname: '', createdAt: '', degreeType: '' }]}
    }
  },
  methods: {
    handleClick (tab, event) {
    }
  },
  computed: {
    attachedDocumentsTable () {
      return this.workingApplication.attachedDocuments.slice(0).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    isReappraisal () {
      return this.workingApplication.applicationType === 'reappraisal'
    },
    ...mapGetters({ currentUser: 'currentUser', userScope: 'userScope', activeRole: 'activeRole' }),
    ...mapState([
      'searchVisible',
      'searchUniVisible',
      'history',
      'assignedApplications',
      'workingApplication',
      'showWorkingApplication',
      'pendingNotifications',
      'loadingAssignedApplications',
      'loadingWorkingApplication'
    ])
  },
  watch: {
    workingApplication: function (newData, oldData) {
      this.activeName = 'first'
    },
    assignedApplications: {
      handler: function (newData, oldData) {
        this.listAssignedApplications = this.assignedApplications.map(
          application => { return { key: application.id, label: `${application.degreeType}, ${application.surname}, ${application.createdAt.substring(0, 10)}`, disabled: false } })
        this.myApplications = []
        this.assignedApplications.forEach(app => {
          this.myApplications.push(app.id)
        })
      },
      deeep: true
    }
  }
}
</script>
<style lang="scss">
.el-transfer-panel .el-transfer-panel__footer {
  text-align: center;
}
div.el-transfer-panel {
  width: 448px;
}
.newApplicationsMenu {
  background-color: #c8ec3c;
  /*color: #7a9db7;*/
}
.el-menu-vertical-demo {
  width: 200px;
  min-height: 400px;
}
.commentText {
  width: 320px;
}
.el-card__body {
  padding: 2px;
}
/*.el-input--small .el-input__inner {*/
  /*width: 150px*/
/*}*/
.el-card {
  margin: 5px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.list-group {
  min-height: 20px;
  overflow: hidden;
}
.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VicePresidentA.vue